import React from 'react';
import {
  compose,
  setDisplayName,
  withProps,
} from 'recompose';
import { FormattedMessage } from 'react-intl';
import Button, { Kind } from '@ux/button';
import * as r from 'ramda';

export const PureSettingsToggle = ({
  text,
  theme,
  onClick,
  buttonSize,
}) => (
  <Button
    theme={theme}
    kind={Kind.SECONDARY_LIGHT}
    size={buttonSize}
    type="button"
    onClick={onClick}
  >
    <FormattedMessage id={`cookie.settings.toggle.${text}`}/>
  </Button>
);

export const enhance = compose(
  setDisplayName('SettingsToggle'),
  withProps((ownerProps) => ({
    text: r.ifElse(
      r.propEq('expanded', true),
      r.always('close'),
      r.always('open'),
    )(ownerProps),
  })),
);

export default enhance(PureSettingsToggle);



// WEBPACK FOOTER //
// ./src/presentation/components/settings/SettingsToggle.js